<template>
  <el-drawer
    v-if="visible"
    :title="'更新已出货数量'"
    :visible.sync="visible"
    direction="rtl"
    :size="1000"
    show-close
    :before-close="() => close()"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        @reload="$emit('reload')"
        @close="close()"
        :amzPurchaseDetailCode="amzPurchaseDetailCode"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="primary"
        size="small"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzPurchaseDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}
</style>
